import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductService } from './../../services/product.service';
import { CartService } from './../../services/cart.service';

import { first } from 'rxjs/operators'
import { ModalDirective } from 'ng-uikit-pro-standard';
import { UserService } from './../../services/user.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss']
})
export class ProductComponent implements OnInit {
  @ViewChild('frame', {static: true}) frame: ModalDirective;

  public category: any;
  public products: any;
  public subcategories: any;
  public product: any;
  public selected_color;
  public checkModel: any = { left: true, middle: false, right: false };
  public radioModel: string = 'Left';
  public user: any;
  public quantity: number
  fullname; email; phone; password; cpassword
  prod; response; error
  colour_index=0; error_response: boolean = false

  constructor(
    public route:ActivatedRoute,
    public ps: ProductService,
    public cs: CartService,
    public router: Router,
    private location: Location,
    public us: UserService
    ){}

    ngOnInit() {
      this.route.queryParams.subscribe(async params => {
        console.log(params)
        if (await params && params.product ) {
          this.product = await JSON.parse(params.product);
          console.log(this.product);

          this.ps.getAllProducts().then(ref=>{
            ref.subscribe(async res=>{
              console.log(res, this.product)
              this.products = await res;
              var products = await this.products.data.filter(async function(hero) {
               return hero.category.id === await this.product.category.id;
             });
             this.slides = this.chunk(products, 3);
            })
          })
        }
      })
    }

    getColor(index, id){
      console.log(index, id)
      this.colour_index = index;
      this.selected_color = id
    }

    goBack() {
      this.location.back(); // <-- go back to previous location on cancel
    }

  slides: any = [[]];
  chunk(arr: any, chunkSize:any) {
    let R = [];
    for (let i = 0, len = arr.length; i < len; i += chunkSize) {
      R.push(arr.slice(i, i + chunkSize));
    }
    return R;
  }

  async addToCart(color_id, quantity){
    console.log(color_id, quantity)
    if(color_id && quantity){
      const my_carts = await [];
      await my_carts.push({product_colour_id: color_id, quantity: quantity})
      await this.cs.addToCart(await JSON.stringify({items: my_carts})).then(ref=>{
        ref.subscribe(res=>{
          this.response = res;
          if(this.response.status === 'success'){
            this.router.navigateByUrl('/cart')
          }
        },
          error =>{
            console.log(error)
            this.error = error
            if(this.error.error){
              if(this.error.error.message === "Unauthenticated."){
                this.frame.show()
              }
            }
          }
        )
      })
    }
    else {
      alert('Kindly select a color and state the quantity required before you proceed')
    }

  }

  async login(email, password, color_id, quantity){
    console.log(email, password, color_id, quantity)
    const obj = await {email: email, password: password}
    this.us.login(await JSON.stringify(await obj)).then(ref=>{
      ref.subscribe(async res=>{
        this.response = await res;
        console.log(this.response, this.response.created);
        if(res){
          await localStorage.setItem('token', JSON.stringify(this.response.access_token));
          await localStorage.setItem('user_details', JSON.stringify(this.response.data));
          await localStorage.setItem('isLoggedIn', 'true')
          console.log(color_id, quantity)
          if(color_id && quantity){
            const my_carts = await [];
            await my_carts.push({product_colour_id: color_id, quantity: quantity})
            await this.cs.addToMyCart(my_carts, this.response.access_token)
            await this.router.navigateByUrl('/cart')
          }
        }
      },
        error => {
          console.log(error)
          this.error = error;
          this.error_response = true
        }
      )
    })
  }



  async register(fullname, email, phone, password, cpassword, color_id, quantity){
    const obj = await {name: fullname, phone: phone, email: email, password: password}
    this.us.register(await JSON.stringify(await obj)).then(ref=>{
      ref.subscribe(async res=>{
        this.response = await res;
        console.log(this.response, this.response.created);
        if(res){
          await localStorage.setItem('token', JSON.stringify(this.response.access_token));
          await localStorage.setItem('user_details', JSON.stringify(this.response.data));
          await localStorage.setItem('isLoggedIn', 'true')
          console.log(color_id, quantity)
          if(color_id && quantity){
            const my_carts = await [];
            await my_carts.push({product_colour_id: color_id, quantity: quantity})
            await this.cs.addToMyCart(await my_carts, await this.response.access_token)
            await this.router.navigateByUrl('/cart')
          }
        }
      },
        error => {
          console.log(error);
          this.error = error;
          this.error_response = true
        }
      )
    })
  }
}
